export default [{
  id: 'site',
  name: 'Site URL',
}];
